import React, { useEffect } from 'react';
import routes from 'app/routes';

import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import { useContext as useUsersContext } from 'components/Users/Context';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';

import ViewList from './Views/List/Index';
import ChooseAddedMethod from './Views/ChooseAddedMethod/Index';
import ManualMethod from './Views/Manual/Index';
import HrSystemConnect from './Views/HrSystem/Connect/Index';
import HrSystemImport from './Views/HrSystem/Import/Index';
import FileImport from './Views/File/ChooseFile/Index';
import SuccessImport from './Views/SuccessImport/Index';

import Assessments from './Views/Assessments/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();
  const { dispatch: dispatchTeams, actions: actionsTeams } = useTeamsContext();
  const { dispatch: dispatchTemplates, actions: actionsTemplates, state: stateTemplates } = useTemplatesContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
    actionsTeams.load(dispatchTeams);
    actionsTemplates.load(dispatchTemplates, stateTemplates.enterpriseId);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.managers.members.index,
      element: <ViewList />,
      children: [
        {
          path: routes.managers.members.assessments(),
          element: <Assessments />,
        },
      ],
    },
    {
      path: routes.managers.members.add,
      element: <ChooseAddedMethod />,
    },
    {
      path: routes.managers.members.manual,
      element: <ManualMethod />,
    },
    {
      path: routes.managers.members.hrSystem.index,
      element: <HrSystemConnect />,
    },
    {
      path: routes.managers.members.hrSystem.import,
      element: <HrSystemImport />,
    },
    {
      path: routes.managers.members.file,
      element: <FileImport />,
    },
    {
      path: routes.managers.members.success,
      element: <SuccessImport />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}
